// base
import { createSlice } from '@reduxjs/toolkit';
import { ALARM_SLICE_NAME } from '../actions/alarm.action';

// thunks
import { getAlarms, getUnreadAlarmCount, postAlarmReaded } from '../thunks/alarm.thunk';
import { AlarmState } from '../models/alarm.model';
import { DEFAULT_PAGE, DEFAULT_PAGE_SIZE } from 'constants/const';

// initialState
const initialState: AlarmState = {
  alarms: [],
  unreadAlarmCount: 0,
  totalMap: {
    totalElements: 0,
    totalPages: 0
  },
  fetchAlarmRequest: {
    keyword: '',
    page: DEFAULT_PAGE,
    size: DEFAULT_PAGE_SIZE
  }
};

// createSlice
const alarmSlice = createSlice({
  name: ALARM_SLICE_NAME,
  initialState,
  reducers: {
    changeFetchAlarmRequest: (state, action) => {
      state.fetchAlarmRequest = {
        ...state.fetchAlarmRequest,
        ...action.payload
      };
    }
  },
  extraReducers: (builder) => {
    builder.addCase(getAlarms.fulfilled, (state, action) => {
      const response = action.payload;

      state.alarms = response.resultList;
      state.totalMap = response.totalMap;
    });

    builder.addCase(getUnreadAlarmCount.fulfilled, (state, action) => {
      state.unreadAlarmCount = action.payload.resultObject;
    });

    builder.addCase(postAlarmReaded.fulfilled, (state, action) => {});
  }
});

export const alarm = alarmSlice.name;
export const alarmReducer = alarmSlice.reducer;
export const alarmActions = alarmSlice.actions;
export const { changeFetchAlarmRequest } = alarmSlice.actions;
export default alarmSlice.reducer;
